



















































import { Component, Vue, Mixins, Watch } from "vue-property-decorator";

import Header from "./components/Header.vue";
import Table from "./components/Table.vue";
import Tag from "./components/Tag.vue";
import loading from "@/mixins/loading";
import tablePagination from "@/mixins/tablePagination";
import debounce from "@/utils/debounce";
import inputPrice from "@/utils/inputPrice";

@Component({
  components: {
    Header,
    Table,
    Tag,
  },
})
export default class Order extends Vue {
  fromDate: string | null = "";
  toDate: string | null = "";
  nickname: string = "";
  phone: string = "";
  receiverName: string = "";
  receiverPhone: string = "";
  orderId: string = "";
  productName: string = "";
  payType: string = "";
  orderStatus: number = 20;
  shippingMethod: string = "";
  summary: { countOrder: number; dividedCost: number; orderSumCost: number } = {
    countOrder: 0,
    dividedCost: 0,
    orderSumCost: 0,
  };

  operationMemberId: number|null = null;
  serviceId: number|null = null;
  subCompanyId: number|null = null;
/**
   * 监听
   */
  @Watch("phone")
  @Watch("orderStatus")
  searchValue() {
    debounce(() => this.handleSearch());
  }

  @Watch("$route", { immediate: true })
  routechange(to: any) {
    let { orderStatus } = to.query;
    if(orderStatus){
      this.$nextTick(()=>{
        this.orderStatus = 12;
      })
    }
  }

  mounted() {
    let route: any = this.$route;
    let { phone } = route.query;
    if(phone){
      this.phone = phone;
    }else{
      this.phone = '';
    }
  }

  /**
   * methods
   */

  importExcel() {
    const header: any = this.$refs.header;
    header.importExcel();
  }

  setSummary(summary:any){
    this.summary = summary;
  }

  // 输入
  inputValue(val: string, type: string) {
    let self: any = this;
    if (type == "expressNo") {
      self[type] = inputPrice(val, "number");
      return;
    }
    if (type == "orderStatus") {
      self[type] = inputPrice(val, "number");
      return;
    }
    self[type] = val;
  }
  // 搜索
  handleSearch() {
    let table: any = this.$refs.table;
    table.getData();
    const header: any = this.$refs.header;
    header.getData();
  }
}
